import { render, staticRenderFns } from "./OsbodEventAddEdit.vue?vue&type=template&id=75ccf164"
import script from "./OsbodEventAddEdit.vue?vue&type=script&lang=js"
export * from "./OsbodEventAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports